import {
  FETCHED_PAIRS,
  FETCHED_MY_ORDERS,
} from '../../types';

import callBC from '../../helpers/bc'
import {getBlake} from '../../passport/get';
import {fromUnit} from '../../../config';
import {deletePending, triggerEvents} from '../../ui/marketplace';
import {lowestDenom} from '../../../config';

export async function getOpenOrders(dispatch,state){
  try {
    let data = await callBC(state.settings.settings,'getOpenOrders',[])
    let orders = [];
    let newPairs = JSON.parse(JSON.stringify(require('../../../config').pairs))

    if(data.result && data.result.ordersList){
      let cleaned = cleanUpOrders(newPairs,data.result.ordersList,state.socket.bcHeight)
      dispatch({
        type:FETCHED_PAIRS,
        payload: cleaned.pairs
      });

      let blake_address = state.passport.blake ? state.passport.blake : await getBlake(dispatch,state);
      let my_orders = cleaned.newOrders.filter(o => {return o.doubleHashedBcAddress === blake_address});

      dispatch({
        type: FETCHED_MY_ORDERS,
        payload: my_orders
      });

      deletePending(my_orders,state,dispatch)
    }

    return Promise.resolve(true)
  }
  catch(err){
    console.log({err})
  }
}

let cleanUpOrders = (pairs,orders,bcHeight) => {
  let newOrders = orders.map(o => {
    o.receivesUnit = fromUnit(o.receivesToChain,o.receivesUnit)
    o.sendsUnit = fromUnit(o.sendsFromChain,o.sendsUnit)
    o.depositLeft = `in ${o.tradeHeight + o.deposit - bcHeight} Blocks`;
    o.settleLeft = `in ${o.tradeHeight + o.settlement - bcHeight} Blocks`;

    if(o.sendsFromChain.toLowerCase() == 'nrg'){
      pairs['auction'].map(({asset,denomination},index)=>{
        if(asset.toLowerCase() == o.receivesToChain.toLowerCase()){
          o.price = o.sendsUnit / o.receivesUnit;
          o.amount = o.receivesUnit;
          pairs['auction'][index].bids.push(o)
        }
      })
    }
    else {
      pairs['bid/ask'].map(({asset,denomination},index)=>{
        if(asset.toLowerCase() == o.sendsFromChain.toLowerCase() && denomination.toLowerCase() == o.receivesToChain.toLowerCase()){
          o.price = o.receivesUnit / o.sendsUnit;
          o.amount = o.sendsUnit;
          pairs['bid/ask'][index].asks.push(o)
        }
        else if(denomination.toLowerCase() == o.sendsFromChain.toLowerCase() && asset.toLowerCase() == o.receivesToChain.toLowerCase()){
          o.price = o.sendsUnit / o.receivesUnit;
          o.amount = o.receivesUnit;
          pairs['bid/ask'][index].bids.push(o)
        }
      })
    }

    o.price = parseFloat(o.price.toString().substring(0,8))
    return o;
  });

  return {newOrders,pairs}
}

// let txs = {}
// orders = orders.filter(o=>{
//   if(txs[o.txHash]) return false
//   else {
//     txs[o.txHash] = true
//     return true
//   }
// })
